import React from "react";
import { Navbar, Container } from "reactstrap";
import HeaderComponent from "components/Header/header";

function Header(props) {
  const sidebarToggle = React.useRef();

  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };

  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }, []);

  return (
    <>
      {!props.hideTitle && <HeaderComponent />}
      <Navbar className={`navbar ${props.hideTitle ? "navbarHelp" : ""}`}>
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-toggle">
              <button
                type="button"
                ref={sidebarToggle}
                className="navbar-toggler"
                onClick={() => openSidebar()}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            {!props.hideTitle && (
              <h5 className="textoSeccion mt-3 ">{props.pathname}</h5>
            )}
          </div>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
